import { useParams } from 'react-router-dom';
import { useMessage, useUpdateMessageTemplate } from '#/components/ui/messages/endpoints';

import { Link, useNavigate } from 'react-router-dom';
import {
  ValidMessageFormValue,
  toMessageFormValue,
} from '#/components/ui/messages/model/messageForm';
import { MessageEditor } from '#/components/ui/messages/MessageEditor/MessageEditor';
import {
  ActionIcon,
  Anchor,
  Button,
  Group,
  Modal,
  Stack,
  Text,
} from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import {
  MessageLoading,
  MessageNotFound,
} from '#/components/ui/messages/components/ui';
import { MessageStateBadge } from '#/components/ui/messages';

// TODO guard

const MessageEditPage = () => {
  const navigate = useNavigate();
  const params = useParams();

  const { data, isLoading, error } = useMessage(params.id);

  const { mutate } = useUpdateMessageTemplate();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSubmit = (values: ValidMessageFormValue) => {
    mutate(values);

    navigate('/messages');
  };

  if (isLoading) {
    return <MessageLoading />;
  }

  if (error || !data) {
    return <MessageNotFound />;
  }

  if (data.state !== 'draft') {
    return (
      <Modal
        opened={true}
        withCloseButton={false}
        onClose={() => {}}
        title={
          <Text>
            目前訊息狀態為
            <MessageStateBadge state={data.state} />
            。無法編輯
          </Text>
        }
        centered
      >
        <Button
          variant="default"
          onClick={() => {
            navigate(`/messages/${data.id}`);
          }}
        >
          檢視訊息
        </Button>
      </Modal>
    );
  }

  return (
    <Stack>
      <Anchor
        component={Link}
        to="/messages"
        w="fit-content"
        c="dimmed"
        fw={500}
      >
        <Group gap={6}>
          <ActionIcon variant="transparent" color="gray" size="sm">
            <IconArrowLeft size={16} />
          </ActionIcon>
          <Text size="sm">返回訊息管理頁</Text>
        </Group>
      </Anchor>
      <MessageEditor
        initialValues={toMessageFormValue(data)}
        handleSubmit={handleSubmit}
      />
    </Stack>
  );
};

export default MessageEditPage;
